import React from 'react';
import {
  BottomProps,
  LeftProps,
  PositionProps,
  RightProps,
  SpaceProps,
  TopProps,
  ZIndexProps,
  bottom,
  left,
  position,
  right,
  space,
  top,
  zIndex,
} from 'styled-system';
import { Box } from '~ui-kit/components/box/box';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';

export interface TagProps extends SpaceProps, PositionProps, TopProps, BottomProps, LeftProps, RightProps, ZIndexProps {
  // children is the content of the tag
  children: React.ReactNode;
  // fontSize of the text
  fontSize?: string;
  // color of the text
  color?: string;
  // background color of the tag
  background?: string;
  // height of the tag
  height?: string | number;
  // fill determines if the tag will fill its container's available space. By default the tag is inline and should only
  // take the space it needs
  fill?: boolean;
  // icon is an element that will be rendered before the children
  icon?: React.ReactNode;
}

export function Tag({
  color = theme.colors.black,
  background = theme.colors.greyBackgroundDark,
  fontSize = '14px',
  height = '22px',
  fill = false,
  icon,
  children,
  ...otherProps
}: TagProps) {
  return (
    <TagContainer
      color={color}
      background={background}
      height={height}
      $fontSize={fontSize}
      $fill={fill}
      {...otherProps}
    >
      {icon}
      {children}
    </TagContainer>
  );
}

const TagContainer = styled(Box).attrs({
  alignItems: 'center',
  justifyContent: 'center',
})<
  { $fontSize: string; $fill: boolean } & SpaceProps &
    PositionProps &
    TopProps &
    BottomProps &
    LeftProps &
    RightProps &
    ZIndexProps
>`
  ${space};
  ${top};
  ${bottom};
  ${left};
  ${right};
  ${position};
  ${zIndex};
  padding: 0 8px;
  font-weight: 700;
  display: ${(props) => (props.$fill ? 'flex' : 'inline-flex')};
  border-radius: ${(props) => props.height};
  font-size: ${(props) => props.$fontSize};
  width: ${(props) => (props.$fill ? '100%' : 'fit-content')};
  font-family: ${theme.fontFamily.montserrat};
  text-align: center;
  backface-visibility: hidden;
  transform: translateZ(0);
`;
